<template>
  <div class="w-100 bg-primary py-5 px-3 d-flex justify-content-center welcome-page-wrapper">
    <div class="d-flex flex-column align-items-center form-wrapper">
      <div class="p-4 logo-container w-100 d-flex flex-column align-items-center">
        <img src="@/../public/img/brand/logo_white.svg" alt="Wallkit" height="60" class="mb-1" />
      </div>

      <div class="d-flex flex-column align-items-center py-5">
        <h1 class="font-weight-light mb-4 text-center">
          {{ $t('login.restore_password') }}
        </h1>

        <p class="text-center mb-4">
          {{ $t('login.create_new_password') }}
        </p>

        <b-form
          @submit.prevent="debounceSubmitReset"
          class="w-100 form-container"
          novalidate
          ref="formReset"
          :validated="formValidatedReset"
        >
          <b-input-group class="position-relative mb-4">
            <b-form-input
              name="new_password"
              v-model="form.newPassword"
              class="w-100 rounded"
              :type="inputTypeNewPassword"
              :placeholder="$t('users.new_password')"
              autocomplete="new-password"
              :required="true"
            />
            <div class="invalid-tooltip">
              {{ $t('form.required_field') }}
            </div>
            <i
              class="fas position-absolute text-white input-icon"
              :class="inputTypeNewPassword === 'password' ? 'fa-eye' : ' fa-eye-slash'"
              @click="togglePasswordVisibility('newPassword')"
            />
          </b-input-group>

          <b-input-group class="position-relative mb-4">
            <b-form-input
              name="confirm_password"
              v-model="form.passwordConfirmation"
              class="w-100 rounded"
              :type="inputTypePasswordConfirm"
              :placeholder="$t('users.password_confirm')"
              autocomplete="new-password"
              :required="true"
            />
            <div class="invalid-tooltip">
              {{ $t('form.required_field') }}
            </div>
            <i
              class="fas position-absolute text-white input-icon"
              :class="inputTypePasswordConfirm === 'password' ? 'fa-eye' : ' fa-eye-slash'"
              @click="togglePasswordVisibility('passwordConfirm')"
            />
          </b-input-group>

          <b-button class="w-100 font-weight-bold p-2" type="submit">
            {{ $t('form.save') }}
          </b-button>

          <b-button variant="link" class="text-white align-self-start px-0 pb-0" to="/login">
            {{ $t('login.back_to_sign_in') }}
          </b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/utils/axios';

export default {
  name: 'ResetPassword',
  middleware: 'no-auth',
  data() {
    return {
      formValidatedReset: false,
      inputTypeNewPassword: 'password',
      inputTypePasswordConfirm: 'password',
      form: {
        newPassword: '',
        passwordConfirmation: '',
      },
      resetCode: '',
      debounceSubmitReset: () => {},
    };
  },
  created() {
    this.debounceSubmitReset = _.debounce(this.resetPassword, 500);
    this.resetCode = this.$route.query.reset;
  },
  computed: {
    passwordsMatch() {
      return this.form.newPassword === this.form.passwordConfirmation;
    },
  },
  methods: {
    togglePasswordVisibility(type) {
      if (type === 'newPassword') {
        this.inputTypeNewPassword = this.inputTypeNewPassword === 'password' ? 'text' : 'password';
      } else {
        this.inputTypePasswordConfirm =
          this.inputTypePasswordConfirm === 'password' ? 'text' : 'password';
      }
    },
    async resetPassword() {
      if (!this.passwordsMatch) {
        this.$noty.error(this.$t('users.passwords_do_not_match'));
        return;
      }

      this.formValidatedReset = true;

      if (this.$refs.formReset && this.$refs.formReset.checkValidity()) {
        try {
          await axios
            .post(
              'admin/confirm-reset-password',
              {
                code: this.resetCode,
                password: this.form.newPassword,
                password_confirm: this.form.passwordConfirmation,
              },
            )
            .then((resp) => {
              if (resp && resp.data) {
                this.$noty.success(this.$t('login.password_reset_successful'));
                this.$router.push({ name: 'Login' });
              }
            })
            .catch((e) => {
              if (e && e.response) {
                this.$noty.error(e.response.data.error_description);
              }
            });
        } catch (err) {
          console.error(err);
        }
      }
    },
  },
};
</script>
